export function downloadDataAsFile(data: Blob, fileName: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(data);
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function base64ToBlob(base64: string, type: string): Blob {
  const byteString = atob(base64);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], {type: type});
}